import { AccountBalance } from "@mui/icons-material";
import { Grid, Stack, Typography } from "@mui/material";
import CustomSimpleAccordion from "qubCommon/Accordions/CustomSimpleAccordion";
import TextInput from "src/qubCommon/Inputs/TextInput";

const ChildMainInstitute = ({ childInstitute, worker }) => {
  const AccordionTitle = () => (
    <Stack direction="row" gap={1}>
      <AccountBalance
        color="primary"
        fontSize="small"
        sx={{ marginLeft: "2px" }}
      />
      <Typography color="primary" sx={{ fontWeight: 1000 }}>
        ΣΤΟΙΧΕΙΑ ΜΟΝΑΔΑΣ
      </Typography>
      <Typography color="primary" sx={{ marginLeft: "18px", fontWeight: 500 }}>
        {`${childInstitute?.abbr} - ΚΛ: ${worker?.lastName || ""} ${worker?.firstName || ""}` || ""}
      </Typography>
    </Stack>
  );

  const AccordionContent = () => (
    <Grid container spacing={2} padding={1}>
      <Grid item xs={12} md={6}>
        <TextInput
          disabled
          name="childInstitute.name"
          label="Μονάδα"
          defaultValue={childInstitute?.name}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          disabled
          name="childInstitute.type"
          label="Τύπος"
          defaultValue={childInstitute?.type}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          disabled
          name="worker.fullName"
          label="Κοινωνικός Λειτουργός"
          defaultValue={`${worker?.lastName || ""} ${worker?.firstName || ""}`}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          disabled
          name="worker.phone"
          label="Τηλέφωνο"
          defaultValue={worker?.phone}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          disabled
          name="worker.email"
          label="Email"
          defaultValue={worker?.email}
        />
      </Grid>
    </Grid>
  );

  return (
    <CustomSimpleAccordion
      title={<AccordionTitle />}
      content={<AccordionContent />}
    />
  );
};

export default ChildMainInstitute;
